
import { Badge } from "@/components/ui/badge";

interface HostSpecificInfoProps {
  hostingStyle: string[] | string | null;
  specialties: string[];
}

export const HostSpecificInfo = ({ hostingStyle, specialties }: HostSpecificInfoProps) => {
  // Safely convert hostingStyle to an array
  const processHostingStyle = (): string[] => {
    if (!hostingStyle) return [];
    
    // If it's already an array, return it
    if (Array.isArray(hostingStyle)) return hostingStyle;
    
    // If it's a string that looks like JSON array
    if (typeof hostingStyle === 'string') {
      if (hostingStyle.startsWith('[') && hostingStyle.endsWith(']')) {
        try {
          const parsed = JSON.parse(hostingStyle);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          // If parsing fails, treat as a single string
        }
      }
      // If it's a regular string or JSON parsing failed
      return [hostingStyle];
    }
    
    return [];
  };

  const hostingStyles = processHostingStyle();

  return (
    <div className="space-y-6">
      {hostingStyles.length > 0 && (
        <div>
          <h3 className="font-semibold mb-2">Hosting Style</h3>
          <div className="flex flex-wrap gap-2">
            {hostingStyles.map((style, idx) => (
              <Badge 
                key={idx}
                variant="secondary"
                className="text-sm py-1"
              >
                {style}
              </Badge>
            ))}
          </div>
        </div>
      )}

      {specialties?.length > 0 && (
        <div>
          <h3 className="font-semibold mb-2">Specialties</h3>
          <div className="flex flex-wrap gap-2">
            {specialties.map((specialty, idx) => (
              <Badge 
                key={idx}
                variant="secondary"
                className="text-sm py-1"
              >
                {specialty}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
